module.exports = __webpack_public_path__ + "img/bonus_symbol_3.a5429164.png";